import useTypography from "./typography";
import useButton from "./button";

const useComponentHooks = () => {
  return {
    useTypography,
    useButton,
  };
};

export default useComponentHooks;
